import React from 'react';
import BottomSheetModal from './BottomSheetModal';
import './AddModal.css';

/**
 * Add Modal Component
 * Form for creating new parameters (voices, roles, formats, audiences)
 */
const AddModal = ({ 
  isOpen, 
  onClose, 
  type = '',
  formData = { name: '', description: '', prompt: '' },
  onSave,
  isLoading = false
}) => {
  const [form, setForm] = React.useState(formData);
  
  // Update local state when prop changes
  React.useEffect(() => {
    setForm(formData);
  }, [formData]);
  
  const handleInputChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };
  
  const handleSave = () => {
    if (!form.name.trim()) {
      alert('Name is required');
      return;
    }
    onSave(form);
    onClose();
  };
  
  const handleCancel = () => {
    setForm(formData); // Reset to original values
    onClose();
  };
  
  const getTypeDisplayName = (type) => {
    const typeMap = {
      'voice': 'Voice',
      'role': 'Role', 
      'format': 'Format',
      'audience': 'Audience',
      'modifier': 'Modifier'
    };
    return typeMap[type] || type;
  };
  
  return (
    <BottomSheetModal
      isOpen={isOpen}
      onClose={handleCancel}
      title={`Create New ${getTypeDisplayName(type)}`}
      maxHeight="70vh"
    >
      <div className="add-modal-content">
        <div className="form-group">
          <label className="form-label">Name</label>
          <input
            type="text"
            value={form.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            className="form-input"
            placeholder={`Enter ${type} name...`}
            disabled={isLoading}
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">Description</label>
          <input
            type="text"
            value={form.description}
            onChange={(e) => handleInputChange('description', e.target.value)}
            className="form-input"
            placeholder={`Enter ${type} description...`}
            disabled={isLoading}
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">Prompt</label>
          <textarea
            value={form.prompt}
            onChange={(e) => handleInputChange('prompt', e.target.value)}
            className="form-textarea"
            placeholder="Enter the prompt that powers this transformation..."
            rows={4}
            disabled={isLoading}
          />
        </div>
        
        <div className="modal-actions">
          <button 
            onClick={handleCancel} 
            className="btn-secondary"
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            onClick={handleSave} 
            className="btn-primary"
            disabled={isLoading || !form.name.trim()}
          >
            {isLoading ? 'Creating...' : `Create ${getTypeDisplayName(type)}`}
          </button>
        </div>
      </div>
    </BottomSheetModal>
  );
};

export default AddModal; 